<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                           <tr>
                               <th class="listHeader tableLinerT" style="width:20%">National</th>
                               <td class="tableLinerT text-left pl-5">{{NAT_NAME_KR}}</td>
                               <th class="listHeader tableLinerT" style="width:20%">Factory</th>
                               <td class="tableLinerT text-left pl-5">{{FAC_NAME_KR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Division</th>
                               <td class="text-left pl-5">{{DVC_DIVISION_INFO}}</td>
                               <th class="listHeader" >Model </th>
                               <td class="text-left pl-5">{{DVC_MODEL}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">ID</th>
                               <td class="text-left pl-5">{{DVC_ID}}</td>
                               <th class="listHeader">Software</th>
                               <td class="text-left pl-5">{{DVC_SW}}</td>
                           </tr>                           
                           <tr>
                               <th class="listHeader">Registered User</th>
                               <td class="text-left pl-5">{{INS_USR}}</td>
                               <th class="listHeader">Approval User</th>
                               <td class="text-left pl-5">{{APRV_USR}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Status</th>
                               <td class="tableLinerB text-left pl-5">{{APRV_INFO}}</td>
                               <th class="listHeader tableLinerB">Registration Date</th>
                               <td class="tableLinerB text-left pl-5">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                       </v-simple-table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <div class="d-flex flat ">
                            <div class="mr-auto align-self-center"><h3>History</h3></div>
                            <div ><v-btn icon color="primary" @click="regOpenHistory"><v-icon>mdi-pencil-plus</v-icon></v-btn></div>
                        </div>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader text-center" style="width:20%;">Date</th>
                                    <th class="listHeader tableLinerR text-center">Memo</th>
                                </tr>
                                <tr v-for="(item) in historyList" :key="item.HIS_SEQ">
                                    <td class="rowList tableLinerR tableLinerB">{{item.INS_DTM}}</td>
                                    <td class="rowList tableLinerB text-left pl-5">{{item.CONT}}</td>
                                </tr>
                                <tr v-if="emptyHistoryFlag==true">
                                    <td colspan="11" class="tableLinerB" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="pa2 my-5">
                            <div>
                                <div class="text-center" v-if="emptyHistoryFlag==false">
                                    <v-pagination
                                    v-model="page"
                                    :length="pagelength"
                                    ></v-pagination>
                                </div>
                            </div>
                        </div>

                            <div class="d-flex justify-space-between dense pa-0">
                                <div class="pa2 " >
                                <v-btn  dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn dark class="deleteBtn ml-2 px-5">Delete</v-btn>
                                <v-btn dark class="registerBtn ml-2 px-6" @click="editInfo()">Edit</v-btn>
                            </div>
                            </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <div class="text-center pb-0 mb-0" >
            <v-form ref="form" v-model="formValid" lazy-validation >
            <v-dialog v-model="historyRegFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                       
                        <span>History Register</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="width:30%;height:40px !important;">작성자</th>
                                    <td class="tableLinerT text-left pl-5" style="height:40px !important;">admin</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="height:40px !important;">작성일</th>
                                    <td class="text-left pl-5" style="height:30px !important;">{{today}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class=" tableLinerB">
                                        <v-textarea
                                        outlined
                                        v-model="histroyCont"
                                        :rules="historyContRules"
                                        class="py-5"
                                        :counter="max"
                                        no-resize
                                        required
                                        ></v-textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions class="justify-end py-5 pr-10">
                        <v-btn color="red lighten-2" style="color:#fff"  @click="closeHistoryDialog">cancel</v-btn>
                        <v-btn color="primary"  @click="addHistory()">save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </v-form>
        </div>

      
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'DeviceDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },
    data () {
        return {
             // login Info
            gnbCode:"2", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Device', disabled: true,},  { text: 'Device Management', disabled: true,}, { text: 'Device List', disabled: true,}, { text: 'Detail', disabled: false,}],
            NavList: [ 
                        { title: 'Device Management', nums: '1',
                            items: [ { title: 'Device List', nums:11, href:'/Device', icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/DeviceWrite', icons:'mdi-lead-pencil' },],
                        },
                    ],       

            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"VCU", summeryTtile2:"MCU", summeryTtile3:"BMS", summeryTtile4:"Charger",

            schSeq:'', schCls:'',
            DVC_DIVISION: "", DVC_DIVISION_INFO: "",
            DVC_CLASS: "", DVC_SEQ: "", DVC_MODEL: "", DVC_ID: "",
            DVC_SW: "", 
            COUNTRY_CODE: "", NAT_NAME_KR: "", FACTORY_CODE: "",FAC_NAME_KR: "", APRV_STATUS: "", APRV_INFO: "",APRV_USR_ID: "", APRV_USR: "", APRV_DTM: "",
            INS_DTM:"", INS_USR_ID:"", INS_USR:"",

            page:1, pagelength:1,
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            today: new Date().toISOString().substr(0, 10),
            histroyCont:"",
            emptyFlag:true,emptyHistoryFlag:true,historyRegFlag:false, historyList:[],
            historyContRules: [
                v => !!v || 'content is required',
                v => v.length <= 100 || 'content must be less than 100 characters',
            ],
            max:100, formValid:false,
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.Seq +" / "+ this.$route.params.Seq);
        this.schSeq = this.$route.params.Seq; 
        this.schCls = this.$route.params.Cls;
        if(this.schSeq != '' && this.schCls != '') {
            this.getInfo();
            this.getHistory();
        }
        window.scrollTo(0, 0);
    },

    methods : {
        

        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "R"
                    , "schDvcSeq": this.schSeq
                    , "schDvcClass": this.schCls
                })
            };

            var apiURL = "https://api.e3bss.com/_APP/POC/dvcInfo.php"; 
                        
            fetch(apiURL, requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json);
                if(json.result == "success") {

                    this.DVC_CLASS = json.DVC_CLASS; this.DVC_SEQ = json.DVC_SEQ; this.DVC_MODEL = json.DVC_MODEL; 
                    this.DVC_SW = json.DVC_SW;
                    this.DVC_ID = json.DVC_ID; this.COUNTRY_CODE = json.COUNTRY_CODE; this.NAT_NAME_KR = json.NAT_NAME_KR; 
                    this.FACTORY_CODE = json.FACTORY_CODE; this.FAC_NAME_KR = json.FAC_NAME_KR; 
                    this.DVC_DIVISION = json.DVC_DIVISION;
                    this.DVC_DIVISION_INFO = json.DVC_DIVISION_INFO;
                    this.APRV_STATUS = json.APRV_STATUS; this.APRV_INFO = json.APRV_INFO;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; this.APRV_DTM = json.APRV_DTM;
                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;
                    this.emptyFlag = false;
                } else {
                    this.emptyFlag = true;
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
        
        regOpenHistory() {
            this.histroyCont = "";
            this.historyRegFlag = true;
        },

        getHistory() {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "dvcSeq": this.schSeq
                    , "dvcType": this.schCls
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.historyList = json.list;
                    this.emptyHistoryFlag = false;
                } else {
                   this.historyList = [];
                    this.emptyHistoryFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        addHistory() {
            this.validate();
            if( this.histroyCont == "" || this.histroyCont < 10 || this.histroyCont.length > 100 ) {
                alert('Please enter more than 10 characters and less than 100 characters');
                this.formValid = false;
            }
            
            //console.log(this.formValid);
            
            if(this.formValid === true) {
                var  requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "C"
                        , "dvcSeq": this.schSeq
                        , "cont": this.histroyCont
                        , "dvcType": this.schCls
                    })
                };
                
                fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json.result );
                    if(json.result == "success") {
                        this.getHistory();
                        this.histroyCont = '';
                        this.historyRegFlag = false;
                    } 
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            } else {
                this.resetValidation();
            }
            
        },
        validate () {
            //alert('a');
            this.$refs.form.validate();
        },
        resetValidation () {
            //alert('b');
            this.$refs.form.resetValidation();
        },
        closeHistoryDialog() {
            this.histroyCont = "";
            this.historyRegFlag = false;
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.histroyCont = "";
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Device'});
        },

        editInfo() {
            //this.schSeq != '' && this.schCls
            this.$router.push({ name: 'DeviceWrite', params: { Seq: this.schSeq, Cls: this.schCls }})
        }

    }

}
</script>
